import React from 'react';
import { withQuery } from '../../../hoc/withGraphql';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import Page from '../../../components/Page/Page';
import SafetyGrid from '../../../components/Home/SafetyGrid/SafetyGrid';
import { HomeProvider } from '../../context/homeContext';
import s from './TermsOfService.css';

import getAllHomePageSettings from './getAllHomePageSettings.graphql'
import { getDynamicTitleByLocale } from '../../../helpers/getDynamicTitle';

class Support extends React.Component {

  render() {
    const { getAllHomePageSettings: { loading, getAllHomePageSettings }, data: { getEditStaticPage, loading: staticLoading }, currentLocale } = this.props
    let homeSettings = {}, dynamicStaticContent, content;
    if (!loading) {
      getAllHomePageSettings && getAllHomePageSettings.homePageData.map((item) => {
        homeSettings[item.name] = item.value;
      })
    }

    const pageBanner = getEditStaticPage && getEditStaticPage.result.pageBanner;
    dynamicStaticContent = getDynamicTitleByLocale({ dynamicHomePageSettings: getEditStaticPage?.result?.dynamicStaticContent, locale: currentLocale })
    content = dynamicStaticContent[0]?.content || getEditStaticPage.result.content;

    return (
      <div>
        {!loading && !staticLoading &&
          <div>
            <HomeProvider value={homeSettings}>
              <div className={s.homeBanner} />
              <Page
                html={content}
                pageBanner={pageBanner}
              />
            </HomeProvider>
          </div>}
      </div>
    );
  }
}

const mapState = (state) => ({
  currentLocale: state?.intl?.locale
})
const mapDispatch = {};

export default compose(
  withStyles(s),
  withQuery(getAllHomePageSettings, {
    name: 'getAllHomePageSettings',
    options: {
      ssr: true
    }
  }),
  connect(mapState, mapDispatch)
)(Support);
